import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { BookOpen, Dna, FileText, FlaskConical, Microscope, Shield } from 'lucide-react';

export default function DatabasesTab() {
  return (
              <div className="grid md:grid-cols-2 gap-4">
                <a href="https://omia.org/home/" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                          <Microscope className="w-5 h-5 text-blue-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">OMIA</h4>
                            <Badge variant="secondary" className="text-xs">NIH Resource</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Online Mendelian Inheritance in Animals - comprehensive listing of all known genetic disorders in dogs
                          </p>
                          <p className="text-xs text-primary mt-1">omia.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://cidd.discoveryspace.ca/" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center">
                          <FileText className="w-5 h-5 text-green-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Canine Inherited Disorders Database</h4>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Sir James Dunn Animal Welfare Centre - disorders organized by category and breed
                          </p>
                          <p className="text-xs text-primary mt-1">cidd.discoveryspace.ca</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.doggenomeannotation.org" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
                          <FlaskConical className="w-5 h-5 text-purple-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">DoGA Database</h4>
                            <Badge variant="secondary" className="text-xs">New 2024</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Dog Genome Annotation Project - comprehensive genomic atlas for dogs and wolves
                          </p>
                          <p className="text-xs text-primary mt-1">doggenomeannotation.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.ofa.org" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center">
                          <Shield className="w-5 h-5 text-amber-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">OFA Database</h4>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Orthopedic Foundation for Animals - centralized canine health database with DNA repository
                          </p>
                          <p className="text-xs text-primary mt-1">ofa.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.broadinstitute.org/scientific-community/science/projects/mammals-models/dog/dog-genome-links" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center">
                          <Dna className="w-5 h-5 text-red-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Broad Institute Dog Genome</h4>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            CanFam assemblies, 2.5M+ SNPs - the reference dog genome used in research worldwide
                          </p>
                          <p className="text-xs text-primary mt-1">broadinstitute.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.instituteofcaninebiology.org/genetics-databases.html" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-teal-100 flex items-center justify-center">
                          <BookOpen className="w-5 h-5 text-teal-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Institute of Canine Biology</h4>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Comprehensive list of genetics databases and resources for dog breeders and researchers
                          </p>
                          <p className="text-xs text-primary mt-1">instituteofcaninebiology.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
              </div>
  );
}
